import React from 'react';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../CategoryCard';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {Grid} from '@material-ui/core';
import {TextBox, SwitchCustom} from '../../../Core/UI';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type BankruptcyProps = {
    parameters: Approval;
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    index: number;
};

const Bankruptcy = observer(({parameters, valueChanged, setCategory, index}: BankruptcyProps) => {
    return (
        <CategoryCard title={'Bankruptcy'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id="bankruptcyYear"
                    label="What year did you file for bankruptcy?"
                    value={parameters.bankruptcyYear?.value}
                    onChange={(value) => valueChanged(parameters.bankruptcyYear, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'What chapter did you file?',
                        name: 'bankruptcyChapter',
                        options: fieldOptions.bankruptcyChapter.options,
                        ...parameters.bankruptcyChapter,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'bankruptcyOpen',
                        label: 'Is the bankruptcy open?',
                        ...parameters.bankruptcyOpen,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            {!parameters.bankruptcyOpen.value && (
                <Grid item xs={4}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            inputVariant="outlined"
                            variant="inline"
                            openTo="year"
                            views={['year', 'month']}
                            label="When was the bankruptcy discharged?"
                            style={{width: '100%', marginTop: 8}}
                            value={parameters.bankruptcyDischargeDate?.value || null}
                            onChange={(date) => valueChanged(parameters.bankruptcyDischargeDate, date)}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            )}
            <Grid item xs={4}>
                <TextBox
                    id="bankruptcyNotes"
                    label="Notes"
                    value={parameters.bankruptcyNotes?.value}
                    onChange={(value) => valueChanged(parameters.bankruptcyNotes, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'bankruptcyMultiple',
                        label: 'Multiple bankruptcies?',
                        ...parameters.bankruptcyMultiple,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            {parameters.bankruptcyMultiple.value && (
                <Grid item xs={4}>
                    <TextBox
                        id="bankruptcyMultipleDetail"
                        label="Details for multiple bankruptcy"
                        value={parameters.bankruptcyMultipleDetail?.value}
                        onChange={(value) => valueChanged(parameters.bankruptcyMultipleDetail, value)}
                    />
                </Grid>
            )}
        </CategoryCard>
    );
});

export default Bankruptcy;
